// @flow

import React from "react";
import { Field, reduxForm, Form } from "redux-form";
import validate from "./validate";
import renderField from "./renderField";
import { Button, Glyphicon } from "react-bootstrap";
import ReactTelephoneInput from "../../../../components/TelephoneInput";
import asyncValidate from "../../YourSummaryPanel/form/asyncValidate";

type Props = {
  handleSubmit: Function,
  onSubmit: Function
};

const WizardFormFirstPage = (props: Props) => {
  const emailFeedbackIcon = <Glyphicon glyph="envelope" />;
  const userFeedbackIcon = <Glyphicon glyph="user" />;
  const phoneFeedbackIcon = <Glyphicon glyph="phone" />;
  const { handleSubmit, onSubmit, handleBlur } = props;

  return (
    <div>
      {props.activeKey === "2" ? (
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Field
            name="email"
            type="email"
            feedbackIcon={emailFeedbackIcon}
            component={renderField}
            label="Email"
            onFocus={() => handleBlur("email")}
          />
          <Field
            name="firstName"
            type="text"
            feedbackIcon={userFeedbackIcon}
            component={renderField}
            label="First Name"
            onFocus={() => handleBlur("firstName")}
          />
          <Field
            name="lastName"
            type="text"
            feedbackIcon={userFeedbackIcon}
            component={renderField}
            label="Last Name"
            onFocus={() => handleBlur("lastName")}
          />
          <Field
            name="phone"
            type="tel"
            feedbackIcon={phoneFeedbackIcon}
            component={ReactTelephoneInput}
            label="Phone"
            onFocus={() => handleBlur("phone")}
          />
          <div className="next-button">
            <Button
              bsSize="large"
              bsStyle="success"
              className="next"
              type="submit"
              onFocus={() => handleBlur("")}
            >
             <span>Next</span>
            </Button>
          </div>
        </Form>
      ) : null}
    </div>
  );
};

export default reduxForm({
  onSubmit: () => val => console.log(val),
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  // shouldValidate(params) {
  //   if (params.nextProps) {
  //     if (params.nextProps.activeKey === '3') return true;
  //   }
  //   return false;
  // },
  validate,
  asyncValidate
})(WizardFormFirstPage);



// WEBPACK FOOTER //
// ./src/containers/QuotePage/TravelDetailsPanel/form/WizardFormFirstPage.js